<template>
  <div
    class="demo-modal"
    :hidden="!visible"
    role="dialog"
    aria-modal="true"
    aria-labelledby="demoTitle"
    @click="onBackdrop"
  >
    <div class="demo-card">
      <button ref="closeBtn" type="button" class="demo-x" aria-label="Close" @click="close()">×</button>
      <span id="demoEyebrow" class="eyebrow">{{ eyebrow }}</span>
      <h3 id="demoTitle">Speak to the team</h3>
      <p>Call or email us and we'll work out how to get you on board.</p>
      <div v-for="c in contacts" :key="c.key" class="demo-row">
        <div>
          <small>{{ c.label }}</small>
          <b :ref="'value-' + c.key">{{ c.value }}</b>
        </div>
        <button type="button" class="btn btn-line btn-sm cpy" @click="copy(c)">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h10"/></svg>
          <span>{{ copied[c.key] ? "Copied" : "Copy" }}</span>
        </button>
      </div>
      <p class="demo-hrs">Phones answered 10am to 5pm weekdays, ACST. Emails answered within one business day.</p>
      <!-- data-auth is handled by LandingPage, which also closes this popup. -->
      <a class="btn btn-red" href="#/home" data-auth="register" style="width: 100%">Or create an account</a>
    </div>
  </div>
</template>

<script>
// Contact popup, opened by any [data-demo] element on the page (see
// LandingPage). The data-demo value only changes the label at the top.
const TOPICS = {
  demo: "Book a demo",
  trial: "Free trial",
  lcd: "LCD players",
  led: "Commercial LED",
  network: "Network plan",
  adverpeople: "Adverpeople",
  advertiser: "Advertise",
  other: "Talk to us",
};

export default {
  name: "DemoModal",
  data() {
    return {
      visible: false,
      eyebrow: TOPICS.demo,
      contacts: [
        { key: "phone", label: "Call us", value: "(08) 8374 4557" },
        { key: "email", label: "Email us", value: "hello@adverpost.com" },
      ],
      copied: { phone: false, email: false },
      opener: null,
    };
  },
  mounted() {
    document.addEventListener("keydown", this.onKey);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.onKey);
  },
  methods: {
    open(topic, opener) {
      this.eyebrow = TOPICS[topic] || TOPICS.demo;
      this.opener = opener || null;
      this.copied = { phone: false, email: false };
      this.visible = true;
      this.$nextTick(() => this.$refs.closeBtn && this.$refs.closeBtn.focus());
    },
    // Focus goes back to whatever opened the popup, except when it closes
    // because the visitor moved on to sign-up or log-in.
    close(restoreFocus = true) {
      if (!this.visible) return;
      this.visible = false;
      if (restoreFocus && this.opener && this.opener.focus) this.opener.focus();
    },
    onBackdrop(e) {
      if (e.target === this.$el) this.close();
    },
    onKey(e) {
      if (e.key === "Escape" && this.visible) this.close();
    },
    copy(c) {
      if (!navigator.clipboard) return this.select(c);
      navigator.clipboard.writeText(c.value).then(
        () => {
          this.copied[c.key] = true;
        },
        () => this.select(c)
      );
    },
    // Clipboard unavailable or blocked: select the text so it can be copied
    // manually, as the published page does.
    select(c) {
      const refs = this.$refs["value-" + c.key];
      const b = refs && refs[0];
      if (!b) return;
      const range = document.createRange();
      range.selectNodeContents(b);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(range);
    },
  },
};
</script>
